import React, { useEffect } from 'react'; 
import Navbar from '../Navbar';
import SolutionsBody from './SolutionsBody';
import Footer from '../Footer';
import { appInsights } from '../../api/AppInsights';

const Solutions = () => {
   useEffect(() => {
      appInsights.trackPageView({ name: 'Solution Page' });
    }, []);
    
  return (
    <>
      <Navbar />
      <SolutionsBody />
      <Footer />
    </>
  );
};

export default Solutions;